export const reThrowErrorWithCustomMessageRTTI = Symbol.for("reThrowErrorWithCustomMessage");
export const throwErrorRTTI = Symbol.for("throwError");
export const throwAndReportErrorRTTI = Symbol.for("throwAndReportError");
export const throwErrorFromErrorResponseRTTI = Symbol.for("throwErrorFromErrorResponse");
export const throwErrorFromResponseRTTI = Symbol.for("throwErrorFromResponse");
